import jwtDecode from 'jwt-decode';
import { REFRESH_TOKEN_START, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_ERROR } from './actionTypes.js';
import storeTokens from './storeTokens.js';

var refreshToken = (async function (_ref) {
  var refreshTokenAdapters = _ref.refreshTokenAdapters,
    state = _ref.state,
    dispatch = _ref.dispatch,
    request = _ref.request,
    tokenKey = _ref.tokenKey;
  var refreshConfig = refreshTokenAdapters.request({
    access_token: state._network.access_token[tokenKey],
    refresh_token: state._network.refresh_token[tokenKey],
    decode: function decode(encodedToken) {
      return jwtDecode(encodedToken);
    },
    scope: state._network.scope,
    state: state
  });
  var refreshResponse = await request.send({
    config: refreshConfig,
    onStart: function onStart(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_START
      }, payload));
    },
    onSuccess: function onSuccess(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_SUCCESS
      }, payload));
    },
    onError: function onError(payload) {
      dispatch(Object.assign({
        type: REFRESH_TOKEN_ERROR
      }, payload));
    }
  });
  var parsedRefreshTokens = refreshTokenAdapters.response({
    data: refreshResponse.data,
    state: state
  });
  await storeTokens({
    dispatch: dispatch,
    tokens: parsedRefreshTokens,
    tokenKey: tokenKey
  });
  return parsedRefreshTokens;
});

export { refreshToken as default };
//# sourceMappingURL=refreshToken.js.map
